import { render, staticRenderFns } from "./CourseVideoPlayer.vue?vue&type=template&id=d31b5538&scoped=true"
import script from "./CourseVideoPlayer.vue?vue&type=script&lang=js"
export * from "./CourseVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoPlayer.vue?vue&type=style&index=0&id=d31b5538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31b5538",
  null
  
)

export default component.exports